import { createNavigationContainerRef } from '@react-navigation/native';
import { create } from 'zustand';
import { combine } from 'zustand/middleware';

// Global ref to NavigationContainer.
export const navigationRef = createNavigationContainerRef();

interface NavigationState {
	activeEventCode: string | null;
	activeEventUuid: string | null;
	fromNotification: boolean;
	notificationOrigin: string;
	isConnected: boolean;
}

const initialState: NavigationState = {
	activeEventCode: null,
	activeEventUuid: null,
	fromNotification: false,
	notificationOrigin: '',
	isConnected: true,
};

export const useNavigationStore = create(
	combine(initialState, (set) => ({
		setActiveEventByCode: (code: string) => set({ activeEventCode: code }),
		setActiveEventByUuid: (uuid: string) => set({ activeEventUuid: uuid }),
		setNotificationOrigin: (type: string) => set({ notificationOrigin: type }),
		// Every NavBar on the stack reports each NetInfo change; an unchanged value must not re-render them all.
		setConnectivityState: (state: boolean) =>
			set((current) => (current.isConnected === state ? current : { isConnected: state })),

		navigate: (routeName: string, params?: object) => {
			(navigationRef.current?.navigate as ((name: string, params?: object) => void) | undefined)?.(routeName, params);
		},

		goBack: () => {
			navigationRef.current?.goBack();
		},

		reset: (routeName: string, params?: object) => {
			navigationRef.current?.reset({
				index: 0,
				routes: [{ name: routeName, params }],
			});
		},

		// Atomically replace the whole stack with the given routes (last one is focused).
		resetToRoutes: (routes: Array<{ name: string; params?: object }>) => {
			if (!routes.length) return;
			navigationRef.current?.reset({
				index: routes.length - 1,
				routes,
			});
		},
	})),
);
